import React from 'react';
import {BaseMixin, ElementaryMixin, ContentMixin, ColorSchemaMixin, NestingLevelMixin} from '../common/common.js';
import Environment from '../environment/environment.js';
import Backdrop from './backdrop.js';

import './slider.less';

export const Slider = React.createClass({

  //@@viewOn:mixins
  mixins: [
    BaseMixin,
    ElementaryMixin,
    ContentMixin,
    ColorSchemaMixin,
    NestingLevelMixin
  ],
  //@@viewOff:mixins

  //@@viewOn:statics
  statics: {
    tagName: 'UU5.Bricks.Slider',
    nestingLevelList: Environment.getNestingLevelList('bigBoxCollection', 'box'),
    classNames: {
      main: 'uu5-bricks-slider',
      input: 'uu5-bricks-slider-input',
      track: 'uu5-bricks-slider-track',
      selection: 'uu5-bricks-slider-selection',
      pointer: 'uu5-bricks-slider-pointer',
      active: 'uu5-bricks-slider-active'
    }
  },
  //@@viewOff:statics

  //@@viewOn:propTypes
  propTypes: {
    // TODO
    //position: React.PropTypes.oneOf(['horizontal', 'vertical']),
    min: React.PropTypes.number,
    max: React.PropTypes.number,
    step: React.PropTypes.number,
    value: React.PropTypes.number,
    onChange: React.PropTypes.func,
    onChanged: React.PropTypes.func
  },
  //@@viewOff:propTypes

  //@@viewOn:getDefaultProps
  getDefaultProps: function () {
    return {
      //position: 'horizontal',
      min: 0,
      max: 10,
      step: 1,
      value: null, // default: min
      onChange: null,
      onChanged: null
    };
  },
  //@@viewOff:getDefaultProps

  //@@viewOn:standardComponentLifeCycle
  getInitialState: function () {
    return {
      value: this._checkValue(this.props.value),
      active: false
    };
  },

  componentWillReceiveProps: function (nextProps) {
    if (nextProps.controlled) {
      this.setValue(nextProps.value);
    }
  },
  //@@viewOff:standardComponentLifeCycle

  //@@viewOn:interface
  getValue: function () {
    return this.state.value;
  },

  setValue: function (value, setStateCallback) {
    this.setState({value: this._checkValue(value)}, setStateCallback);
    return this;
  },

  increase: function (value, setStateCallback) {
    this.setState(prevState => {
      return {value: this._checkValue(prevState.value + (value || this.props.step))};
    }, setStateCallback);
    return this;
  },

  decrease: function (value, setStateCallback) {
    this.setState(prevState => {
      return {value: this._checkValue(prevState.value - (value || this.props.step))};
    }, setStateCallback);
    return this;
  },
  //@@viewOff:interface

  //@@viewOn:overridingMethods
  //@@viewOff:overridingMethods

  //@@viewOn:componentSpecificHelpers
  _checkValue: function (value) {
    if (value === null) {
      value = this.props.min;
    } else {
      value = Math.round(value / this.props.step) * this.props.step;

      if (value < this.props.min) {
        value = this.props.min;
      } else if (value > this.props.max) {
        value = this.props.max;
      }
    }

    return value;
  },

  _changeValue: function (value, e) {
    var onChange;
    var onChanged;
    if (this.getValue() !== value) {
      onChange = this._getOnChange(value, e);
      !onChange && (onChanged = this._getOnChanged(value, e));

      onChange ? onChange(this) : this.setValue(value, onChanged);
    }

    return this;
  },

  _activate: function (e) {
    var value = this._countValue(e);

    var onChange;
    var onChanged;
    if (this.getValue() !== value) {
      onChange = this._getOnChange(value, e);
      !onChange && (onChanged = this._getOnChanged(value, e));
    }

    var newState = {active: true};
    !onChange && (newState.value = value);

    this.setState(newState, (onChange || onChanged) && function () {
        onChange ? onChange(this) : onChanged(this);
      }.bind(this));
    return this;
  },

  _deactivate: function (e) {
    this.setState({active: false});
    return this;
  },

  _isActive: function () {
    return this.state.active;
  },

  _move: function (e) {
    if (this._isActive()) {
      this._changeValue(this._countValue(e), e);
    }
    return this;
  },

  _getOnChange: function (value, e) {
    var onChange;
    if (typeof this.props.onChange === 'function') {
      var slider = this;
      onChange = function () {
        slider.props.onChange({value: value, component: slider, event: e});
      };
    }
    return onChange;
  },

  _getOnChanged: function (value, e) {
    var onChanged;
    if (typeof this.props.onChanged === 'function') {
      var slider = this;
      onChanged = function () {
        slider.props.onChanged({value: value, component: slider, event: e});
      };
    }
    return onChanged;
  },

  _getStartPositions: function (el) {
    var xPos = 0;
    var yPos = 0;

    while (el) {
      xPos += el.offsetLeft - el.scrollLeft + el.clientLeft;
      yPos += el.offsetTop - el.scrollTop + el.clientTop;

      el = el.offsetParent;
    }

    return {
      x: xPos,
      y: yPos
    };
  },

  _countValue: function (e) {
    var sliderStart = this._getStartPositions(this.track).x;
    var sliderWidth = this.track.offsetWidth;
    var actualPosition = e.clientX;
    if (e.touches) {
      actualPosition = e.touches.item(0).clientX;
    }

    var absolutePosition = actualPosition - sliderStart;
    var end = sliderWidth;

    var min = this.props.min;
    var max = this.props.max;
    var step = this.props.step;

    var absoluteMax = max - min;

    var realValue = absolutePosition / (end / absoluteMax);
    var value = min + Math.round(realValue / step) * step;
    value > this.props.max && (value = this.props.max);
    value < this.props.min && (value = this.props.min);

    return value;
  },

  _getMainAttrs: function () {
    var attrs = this.buildMainAttrs();

    if (!this.isDisabled()) {
      this._isActive() && (attrs.className += ' ' + this.getClassName().active);

      attrs.onMouseDown = this._activate;
      attrs.onMouseMove = this._move;
      attrs.onMouseUp = this._deactivate;
      attrs.onTouchStart = this._activate;
      attrs.onTouchMove = this._move;
      attrs.onTouchEnd = this._deactivate;
      attrs.onMouseLeave = this._deactivate;
    }

    return attrs;
  },

  _getInputAttrs: function () {
    var attrs = {
      className: this.getClassName().input,
      type: "range",
      name: this.getName(),
      min: this.props.min,
      max: this.props.max,
      step: this.props.step,
      value: this.getValue(),
      disabled: this.isDisabled()
    };

    if (!this.isDisabled()) {
      var slider = this;
      attrs.onChange = function (e) {
        slider._changeValue(e.target.value, e);
      };
    }

    return attrs;
  },

  _getBackdropProps: function () {
    var backdropId = this.getId() + "-backdrop";
    var slider = this;

    return {
      hidden: !this._isActive(),
      id: backdropId,
      onClick: function (backdrop, event) {
        event.target.id === backdropId && slider._deactivate();
      },
      mainAttrs: {
        onMouseUp: this._deactivate,
        onTouchEnd: this._deactivate
      }
    };
  },

  _getTrackAttrs: function () {
    var slider = this;
    return {
      className: this.getClassName().track,
      ref: function (div) {
        slider.track = div;
      }
    };
  },

  _getSelectionAttrs: function () {
    return {
      className: this.getClassName().selection,
      style: {width: (this.getValue() - this.props.min) / (this.props.max - this.props.min) * 100 + '%'}
    };
  },

  _getPointerAttrs: function () {
    return {
      className: this.getClassName().pointer
    };
  },
  //@@viewOff:componentSpecificHelpers

  //@@viewOn:render
  render: function () {
    return (
      this.getNestingLevel()
        ? (
          <div {...this._getMainAttrs()}>
            <input {...this._getInputAttrs()} />
            <Backdrop {...this._getBackdropProps()} />
            <div {...this._getTrackAttrs()}>
              <div {...this._getSelectionAttrs()}>
                <div {...this._getPointerAttrs()}>
                  {this.getChildren()}
                </div>
              </div>
            </div>
          </div>
        ) : null
    );
  }
  //@@viewOff:render
});

export default Slider;



// WEBPACK FOOTER //
// ./bricks/slider.js